import dayjs from 'dayjs';

import type { CreateInvoiceTemplatePayload, UpdateInvoiceTemplatePayload } from '~/api/invoiceTemplates';

import { flattenFormSectionsToLines } from '~/features/documents';

import type { InvoiceTemplateForm } from './CreateEditInvoiceTemplateForm.types';

export const mapInvoiceTemplateFormDataToPayload = (data: InvoiceTemplateForm) => {
  return {
    brandId: data.brandId,
    clientContactId: data.contactId,
    clientId: data.clientId,
    clientReference: data.clientReference,
    conditionId: data.condition?.type === 'condition' ? data.condition.id : null,
    customAgreementId: data.condition?.type === 'customAgreement' ? data.condition.id : null,
    customConditionId: data.condition?.type === 'customCondition' ? data.condition.id : null,
    description: data.description,
    lines: data.sections ? flattenFormSectionsToLines(data.sections) : [],
    numberingSeriesId: data.numberingSeriesId,
    paymentTerm: data.paymentTerm,
    paymentTermEndOfMonth: data.paymentTermEndOfMonth,
    specialConditions: data.specialConditions,
    title: data.title,
    interval: data.interval,
    nextInvoiceAt: data.nextInvoiceAt !== null ? dayjs(data.nextInvoiceAt).format('YYYY-MM-DD') : null,
  } satisfies CreateInvoiceTemplatePayload | UpdateInvoiceTemplatePayload;
};
